module.exports = __webpack_public_path__ + "static/media/Xira_privacy_policy.c756369b.pdf";